import { UserImage } from '@photosi/rn-components/user-image/UserImage';
import { StyleSheet } from 'react-native';
import Animated, { useAnimatedStyle, useSharedValue, withSpring, withTiming } from 'react-native-reanimated';
import { useResponsiveScale } from '../../../contexts/ResponsiveScaleContext';
import { IUserImageAreaModel } from 'src/store/_models/userImageArea';
import { neutrals } from 'src/theme/colors';
import { UserImageArea } from '@photosi/rn-components/user-image-area/UserImageArea';
import { useEffect } from 'react';

export type UserImageAreaCursorProps = {
  x: number;
  y: number;
  userImageArea: IUserImageAreaModel;
};

export const UserImageAreaCursor = ({ x, y, userImageArea }: UserImageAreaCursorProps) => {
  const { responsiveScaleSV } = useResponsiveScale();
  const scaleValueSV = useSharedValue(0.6);
  const opacityValueSV = useSharedValue(0);
  const userImage = userImageArea.userImage;

  useEffect(() => {
    scaleValueSV.value = withSpring(0.7, {
      stiffness: 700,
      damping: 10,
      restSpeedThreshold: 1,
      mass: 4,
    });

    opacityValueSV.value = withTiming(1, { duration: 200 });
  }, []);

  const animatedStyle = useAnimatedStyle(() => ({
    width: userImageArea.width * responsiveScaleSV.value,
    height: userImageArea.height * responsiveScaleSV.value,
    transform: [{ scale: scaleValueSV.value }],
    left: x - (userImageArea.width * responsiveScaleSV.value) / 2,
    top: y - (userImageArea.height * responsiveScaleSV.value) / 2,
    opacity: opacityValueSV.value,
  }));

  return userImage ? (
    <Animated.View
      style={[
        styles.dragCursor,
        animatedStyle,
        {
          opacity: userImageArea ? 1 : 0,
          overflow: 'hidden',
        },
      ]}
    >
      <UserImageArea userImageArea={userImageArea} ignoreOffsets>
        <UserImage userImage={userImage} />
      </UserImageArea>
    </Animated.View>
  ) : null;
};

const styles = StyleSheet.create({
  dragCursor: {
    pointerEvents: 'none',
    position: 'absolute',
    borderRadius: 6,
    zIndex: 5,
    backgroundColor: neutrals.white,
    borderWidth: 1,
    borderColor: '#ccc',
    justifyContent: 'center',
    alignItems: 'center',
  },
});
